import { Controller } from "@hotwired/stimulus"

// The start-date row in season setup: the weekday beside the field, and the
// end-date override.
//
// `ends_on` is normally derived from the schedule (the server does it in
// derive_ends_on_if_needed), so the row states that rather than asking. The
// override exists for fixed-window seasons and can be handed back.
const WEEKDAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
]

export default class extends Controller {
  static targets = [
    "startsOn",
    "weekday",
    "endsSummary",
    "endRow",
    "endsOn",
    "endToggle",
  ]

  connect() {
    this.startsOnChanged()
    // The end date is normally derived, and once a schedule exists the row
    // states it ("Ends Sun 08 Nov 2026") rather than opening an input over it.
    // The override is a click away either way.
  }

  startsOnChanged() {
    if (!this.hasStartsOnTarget || !this.hasWeekdayTarget) return
    const value = this.startsOnTarget.value
    if (!value) {
      this.weekdayTarget.textContent = ""
      return
    }
    // Parsed as a local date: `new Date("2026-09-06")` is UTC midnight and can
    // land on the previous day west of Greenwich.
    const [y, m, d] = value.split("-").map(Number)
    this.weekdayTarget.textContent = WEEKDAYS[new Date(y, m - 1, d).getDay()]
  }

  toggleEnd() {
    this.endRowTarget.classList.contains("hidden")
      ? this._showEnd()
      : this._hideEnd()
  }

  _showEnd() {
    this.endRowTarget.classList.remove("hidden")
    this.endToggleTarget.textContent = "Use the schedule"
    this.endsSummaryTarget.textContent = "on the date you set"
  }

  _hideEnd() {
    this.endRowTarget.classList.add("hidden")
    // Clearing matters: a left-behind value would win over the derived one.
    if (this.hasEndsOnTarget) this.endsOnTarget.value = ""
    this.endToggleTarget.textContent = "Set end date"
    this.endsSummaryTarget.textContent = "after the last round"
  }
}
